import { useDispatch, useSelector } from "react-redux"

import SurgicalDrawer1 from "./drawers/SurgicalDrawer1"
import SurgicalDrawer2 from "./drawers/SurgicalDrawer2"
import SurgicalDrawer3 from "./drawers/SurgicalDrawer3"
import DeleteSurgery from "./DeleteSurgery"
import { surgicalDrawerBUttons } from "../../../../assets/data"
import { surgicalActions } from "../../../../store/surgical"

import classes from './SurgicalDrawer.module.css'

export default function SurgicalDrawer({itemData, apiCase}) {
    const dispatch = useDispatch()

    const activeTab = useSelector(state => state.surgical.activeTab)

    const switchTabHandler = (tabId) => {
        dispatch(surgicalActions.setActiveTab(tabId))
    }

    // useEffect(() => {
    //     if (itemData.surgery_stage) {
    //         dispatch(surgicalActions.setActiveTab(checkCurentStageForSurgery(itemData.surgery_stage)))
    //     }
    // }, [itemData.surgery_stage])


    return <div className={classes.container}>
        <div className={classes.drawer_header_row}>
            <div className={classes.drawer_header_tabs}>
                {surgicalDrawerBUttons.map(item => (
                    <button key={item.id} onClick={() => switchTabHandler(item.id)} className={`${classes.tab} ${activeTab === item.id ? classes.active : ''}`}>{item.label}</button>
                ))}
            </div>
            <div className={classes.drawer_header_actions} onClick={(e) => e.stopPropagation()}>
                <DeleteSurgery itemData={itemData} />
            </div>
        </div>
        {activeTab === 1 && <SurgicalDrawer1 itemData={itemData} apiCase={apiCase}/>}
        {activeTab === 2 && <SurgicalDrawer2 itemData={itemData} apiCase={apiCase}/>}
        {activeTab === 3 && <SurgicalDrawer3 itemData={itemData} apiCase={apiCase}/>}

    </div>
}